import React from 'react'
import CardTable from './CardTable'
import {withBalanceContainer}  from "../../normalizer"

const Card  = (props) => {
  const { campaign, points, ...rest } = props
  return <CardTable {...props}>  </CardTable>
}

export default withBalanceContainer(Card)
